<template>
  <div>
    <vue-mermaid
      :nodes="statesData"
      type="graph LR"
      @nodeClick="editNode"
    ></vue-mermaid>
  </div>
</template>
<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
  },
  data: function () {
    return {
      statesData: [],
    };
  },

  methods: {
    editNode(nodeId) {},
  },
  async created() {
    await this.items.map(async (item) => {
      const getTrans = [];
      const getTriggs = [];
      await item.transitions.map((trans) => {
        getTrans.push(`${trans.to_state}`);
      });

      await item.triggers.map((triggs) => {
        getTriggs.push(`--${triggs.name}--->`);
      });
      let colorType = "";
      if (item.type == 1) {
        colorType = "#198754";
      } else if (item.type == 3) {
        colorType = "#df4759";
      } else {
        colorType = "#3d8ee5";
      }
      this.statesData.push({
        id: `${item.id}`,
        text: `${item.name}`,
        link: getTriggs,
        next: getTrans,
        editable: true,
        style: `fill:${colorType},stroke:${colorType},stroke-width:2px;color:#fff`,
      });
    });
  },
};
</script>
<style scoped>
g .nodes .node g .label {
  color: #fff !important;
}
</style>
